export default __webpack_public_path__ + "static/in-w2-amazon-main-diagram-en5-442476354d814b00b41446b9c951762b.webp";